const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.CARTS)

export const apiClientCarts = {
	createClientOrder: async (payload: IOrderPayloadCreate) => {
		const { data } = await apiCommon<ICart>(`${groupPrefix}/diets`, {
			method: 'POST',
			body: payload,
		})
		return data
	},
	updateClientOrder: async (payload: IOrderPayloadCreate): Promise<ICart> => {
		const { data } = await apiCommon<ICart>(`${groupPrefix}/diets`, {
			method: 'POST',
			body: payload,
		})

		return data
	},
	changeCartStatus: async (cartUUID: string, status: EOrderCartStatus) => {
		const { data } = await apiCommon<ICart>(`${groupPrefix}/${cartUUID}/change-status`, {
			method: 'POST',
			body: { status },
		})
		return Cart(data)
	},
	changeCartStatusWithWallets: async (cartUUID: string, payload: IChangeCartStatusWithWalletsPayload) => {
		const { data } = await apiCommon<ICart>(`${groupPrefix}/${cartUUID}/change-status`, {
			method: 'POST',
			body: payload,
		})
		return Cart(data)
	},
	confirmCart: async (cartUUID: string) => {
		const { data } = await apiCommon<ICart>(`${groupPrefix}/${cartUUID}/confirm`, {
			method: 'POST',
		})
		return data
	},
	activateClientOrder: async (cartUUID: string): Promise<void> => {
		await apiCommon<IOrder>(`${groupPrefix}/${cartUUID}/confirm`, { method: 'POST' })
	},
	cancelCart: async (cartUUID: string) => {
		await apiCommon(`${groupPrefix}/${cartUUID}/cancel`, {
			method: 'POST',
		})
	},
}
